import React, {useEffect, useRef, useState} from "react";
import CandidateHeader from "../components/Headers/CandidateHeader";
import "../assets/css/candidate.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {Card, CardBody, CardHeader, Col, Container, Nav, Row} from "reactstrap";
import BasicInfo from "../views/candidate/basicInfo";
import Education from "../views/candidate/education";
import Greetings from "../views/candidate/greetings";
import step1 from "../assets/img/steps/candidate/01.png";
import step2 from "../assets/img/steps/candidate/02.png";
import step3 from "../assets/img/steps/candidate/03.png";
import step4 from "../assets/img/steps/candidate/04.png";
import step5 from "../assets/img/steps/candidate/05.png";
import step6 from "../assets/img/steps/candidate/06.png";
import step1Active from "../assets/img/steps/candidate/01-active.png";
import step2Active from "../assets/img/steps/candidate/02-active.png";
import step3Active from "../assets/img/steps/candidate/03-active.png";
import step4Active from "../assets/img/steps/candidate/04-active.png";
import step5Active from "../assets/img/steps/candidate/05-active.png";
import step6Active from "../assets/img/steps/candidate/06-active.png";
import Completed from "../views/candidate/completed";
import activ8Logo from "../assets/img/icons/user/activ8Logo.png";
import checkLogo from "../assets/img/templates/check.png";
import {v4 as uuidv4} from "uuid";
import {NotificationManager} from "react-notifications";
import {fetchCandidateConfig, saveToFirebase, uploadFileToFirebaseStorageAndGetDownloadUrl,} from "../util/Helper";
// import {props} from "react-csv/lib/metaProps";
import {useParams} from "react-router-dom";
import {addUserInGame} from "../util/UploadUsers";
import {doc, getDoc} from "firebase/firestore";
import {getDb} from "../util/Constants";
import Experience from "../views/candidate/experience";
import OrgQuestions from "../views/candidate/orgQuestions";
import CandidateSpecific from "../views/candidate/candidateSpecific";

const CandidateFlow = () => {
    const {id} = useParams();
    const [activeTab, setActiveTab] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [candidate, setCandidate] = useState({});
    const sliderRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [step, setStep] = useState(1);
    const [eventData, setEventData] = useState({});
    const [isEventDataLoaded, setIsEventDataLoaded] = useState(false);
    const [isEventActive, setIsEventActive] = useState(false);
    const [isCompleted, setIsCompleted] = useState({
        basicInfo: false,
        education: false,
        experience: false,
        orgQuestions: false,
        candidateSpecific: false,
    });

    const settings = {
        dots: false,
        // className: "center",
        centerMode: true,
        infinite: false,
        centerPadding: 0,
        slidesToShow: 3,
        speed: 500,
        initialSlide: 0,
    };
    const [candidateConfig, setCandidateConfig] = useState(null);
    const [progressIncrement, setProgressIncrement] = useState(0);
    const [lastComponent, setLastComponent] = useState(false);

    useEffect(() => {
        console.log(id);
        getEventData().then((event) => {
            setEventData(event || {});
            console.log(event, "Event data here");
            if (event && event.cf_startTime && event.cf_endTime) {
                setIsEventActive(validateEvent(event));
            }
            setIsEventDataLoaded(true);
        });
    }, []);

    const getEventData = async () => {
        const eventRef = doc(getDb(), "Events", id);
        const eventSnap = await getDoc(eventRef);
        if (eventSnap.exists()) {
            return eventSnap.data();
        }
        return null;
    };


    useEffect(() => {
        async function getCandidateConfig() {
            try {
                const config = await fetchCandidateConfig("util", "candidate_config");
                console.log("data", config);
                if (config) {
                    setProgressIncrement(calculateProgressIncrement(config));
                }

                setCandidateConfig(config); // Assuming you have a state variable for config
            } catch (error) {
                console.error("Error fetching candidate config:", error);
            }
        }

        getCandidateConfig();
    }, [id]);

    useEffect(() => {
        console.log(isEventActive, "Is event active");
    }, [isEventActive]);

    const calculateProgressIncrement = (config) => {
        const enabledSections = [
            "basicInfo",
            "education",
            "experience",
            "candidateSpecific",
            "orgQuestions",
        ].filter((section) => config[section]?.enabled);
        console.log(100 / enabledSections.length);

        return 100 / enabledSections.length;
    };
    const validateEvent = (event) => {
        if (!event || !event.cf_startTime || !event.cf_endTime) {
            return false;
        }
        const currentTimestamp = Math.floor(Date.now() / 1000);
        const {cf_startTime, cf_endTime} = event;
        return (
            currentTimestamp >= cf_startTime.seconds &&
            currentTimestamp <= cf_endTime.seconds
        );
    };
    // Helper function to get the last enabled step
    const getLastEnabledStep = () => {
        const sections = [
            "basicInfo",
            "education",
            "experience",
            "orgQuestions",
            "candidateSpecific",
        ];

        // Find the last enabled section
        for (let i = sections.length - 1; i >= 0; i--) {
            if (candidateConfig?.[sections[i]]?.enabled) {
                return sections[i];
            }
        }
        return null;
    };

    const toggle = () => setIsOpen(!isOpen);
    //   const switchComponent = (value) => {
    //     console.log(value);

    //     console.log("switching", id.includes("packages"));
    //     if (!id.includes("packages")) setActiveTab(value);
    //   };

    // const switchComponent = (value) => {
    //   console.log(value);
    //   if (value === "completed") {
    //     setActiveTab("completed");
    //     return; // Exit the function since we've switched to completed
    //   }

    //   // Create an array of section keys in the order they should appear
    //   const sections = [
    //     "basicInfo",
    //     "education",
    //     "experience",
    //     "orgQuestions",
    //     "candidateSpecific",
    //   ];

    //   // Find the index of the current section
    //   let currentIndex = sections.indexOf(value);

    //   // Loop to find the next enabled section
    //   while (currentIndex < sections.length) {
    //     const currentSection = sections[currentIndex];
    //     if (candidateConfig?.[currentSection]?.enabled) {
    //       // If the section is enabled, switch to it
    //       if (!id.includes("packages")) setActiveTab(currentSection);
    //       break;
    //     }
    //     currentIndex++;
    //   }
    // };

    const switchComponent = (value) => {
        console.log(value);
        if (value === "completed") {
            setActiveTab("completed");
            setLastComponent(true);
            return;
        }

        const sections = [
            "basicInfo",
            "education",
            "experience",
            "orgQuestions",
            "candidateSpecific",
        ];

        let currentIndex = sections.indexOf(value);
        let lastComponent = false;

        // Loop to find the next enabled section
        while (currentIndex < sections.length) {
            const currentSection = sections[currentIndex];

            if (candidateConfig?.[currentSection]?.enabled) {
                // Check if this is the last enabled section
                const remainingEnabledSections = sections
                    .slice(currentIndex + 1)
                    .some((section) => candidateConfig[section]?.enabled);

                if (!remainingEnabledSections) {
                    console.log("found Last");
                    lastComponent = true;
                }

                // Set active tab and update lastComponent status
                setActiveTab(currentSection);
                break;
            }

            currentIndex++;
        }

        // Set last component status
        setLastComponent(lastComponent); // Assuming you have a state variable for lastComponent
    };

    const switchBack = () => {
        // Create an array of section keys in the order they should appear
        const sections = [
            "basicInfo",
            "education",
            "experience",
            "orgQuestions",
            "candidateSpecific",
        ];

        // If we're on the completed screen, go back to the last enabled step
        if (activeTab === "completed") {
            const lastEnabled = getLastEnabledStep();
            if (lastEnabled) {
                setActiveTab(lastEnabled);
                // We're coming back from Completed, so this is NOT the last component anymore
                setLastComponent(false);
                return;
            }
            // If there's no enabled step found, fall through to greetings
        }

        // Find the index of the current active tab
        const currentIndex = sections.indexOf(activeTab);

        // Loop backwards to find the previous enabled section
        for (let i = currentIndex - 1; i >= 0; i--) {
            const previousSection = sections[i];
            if (candidateConfig?.[previousSection]?.enabled) {
                // If the section is enabled, switch to it
                setActiveTab(previousSection);

                // Update lastComponent: true when this previousSection is the last enabled section
                const lastEnabled = getLastEnabledStep();
                setLastComponent(lastEnabled === previousSection);
                return; // Exit the loop once we find the enabled section
            }
        }

        // If no previous enabled section found, go back to greetings (null) and clear lastComponent
        setActiveTab(null);
        setLastComponent(false);
    };

    //slider functions
    const nextSlide = () => {
        if (sliderRef.current) {
            sliderRef.current.slickNext();
        }
    };
    const prevSlide = () => {
        if (sliderRef.current) {
            sliderRef.current.slickPrev();
        }
    };
    const goToSlide = (slideIndex) => {
        if (sliderRef.current) {
            sliderRef.current.slickGoTo(slideIndex);
        }
    };

    const handleSubmit = async (candidate) => {
        try {
            console.log("isCompleted before", isCompleted);

            setIsLoading(true);
            const documentId = await uuidv4();
            if (candidate?.resume) {
                candidate.resume = await uploadFileToFirebaseStorageAndGetDownloadUrl(
                    candidate?.resume,
                    id
                );
            }

            if (candidate?.drivingLicenseFile) {
                candidate.drivingLicenseFile =
                    await uploadFileToFirebaseStorageAndGetDownloadUrl(
                        candidate?.drivingLicenseFile,
                        id
                    );
            }
            console.log(candidate, "Candidate before saving");
            const result = await saveToFirebase(
                "candidates",
                documentId,
                candidate,
                id
            );
            await addUserInGame(candidate, id);
            console.log(result);
            if (result) {
                setIsLoading(false);
                setProgress(100);
                // setStep(6);
                console.log("isCompleted", isCompleted);

                let temp = {...isCompleted};
                temp.candidateSpecific = true;
                setIsCompleted(temp);
                console.log(temp);

                switchComponent("completed");
                // goToSlide(5);
            } else {
                setIsLoading(false);
                NotificationManager.error("Something went wrong");
            }
        } catch (err) {
            console.log(err, "Error in submitting all");
            setIsLoading(false);
            NotificationManager.error("Something went wrong");
        }
    };

    const renderContent = () => {
        switch (activeTab) {
            case "basicInfo":
                if (!lastComponent) window.scrollTo(0, 0);
                return (
                    candidateConfig?.basicInfo.enabled && (
                        <BasicInfo
                            switchComponent={switchComponent}
                            gotoSlide={goToSlide}
                            candidate={candidate}
                            setCandidate={setCandidate}
                            setProgress={setProgress}
                            setStep={setStep}
                            isCompleted={isCompleted}
                            setIsCompleted={setIsCompleted}
                            switchBack={switchBack}
                            progressIncrement={progressIncrement}
                            progress={progress}
                            lastComponent={lastComponent}
                            handleSubmit={handleSubmit}
                            isLoading={isLoading}
                            basicInfo={candidateConfig?.basicInfo}
                        />
                    )
                );

            case "education":
                if (!lastComponent) window.scrollTo(0, 0);
                return (
                    <Education
                        switchComponent={switchComponent}
                        gotoSlide={goToSlide}
                        candidate={candidate}
                        setCandidate={setCandidate}
                        setProgress={setProgress}
                        setStep={setStep}
                        isCompleted={isCompleted}
                        setIsCompleted={setIsCompleted}
                        handleSubmit={handleSubmit}
                        isLoading={isLoading}
                        switchBack={switchBack}
                        progressIncrement={progressIncrement}
                        progress={progress}
                        lastComponent={lastComponent}
                        education={candidateConfig?.education}
                    />
                );
            case "experience":
                if (!lastComponent) window.scrollTo(0, 0);
                return (
                    <Experience
                        switchComponent={switchComponent}
                        gotoSlide={goToSlide}
                        candidate={candidate}
                        setCandidate={setCandidate}
                        setProgress={setProgress}
                        setStep={setStep}
                        handleSubmit={handleSubmit}
                        isLoading={isLoading}
                        isCompleted={isCompleted}
                        setIsCompleted={setIsCompleted}
                        switchBack={switchBack}
                        progressIncrement={progressIncrement}
                        progress={progress}
                        lastComponent={lastComponent}
                        experience={candidateConfig?.experience}
                    />
                );
            case "orgQuestions":
                if (!lastComponent) window.scrollTo(0, 0);
                return (
                    <OrgQuestions
                        switchComponent={switchComponent}
                        gotoSlide={goToSlide}
                        candidate={candidate}
                        setCandidate={setCandidate}
                        setProgress={setProgress}
                        setStep={setStep}
                        handleSubmit={handleSubmit}
                        isLoading={isLoading}
                        isCompleted={isCompleted}
                        setIsCompleted={setIsCompleted}
                        switchBack={switchBack}
                        progressIncrement={progressIncrement}
                        progress={progress}
                        lastComponent={lastComponent}
                        orgQuestions={candidateConfig?.orgQuestions}
                    />
                );
            case "candidateSpecific":
                if (!lastComponent) window.scrollTo(0, 0);
                return (
                    <CandidateSpecific
                        switchComponent={switchComponent}
                        gotoSlide={goToSlide}
                        candidate={candidate}
                        setCandidate={setCandidate}
                        setProgress={setProgress}
                        setStep={setStep}
                        handleSubmit={handleSubmit}
                        isLoading={isLoading}
                        isCompleted={isCompleted}
                        setIsCompleted={setIsCompleted}
                        switchBack={switchBack}
                        progressIncrement={progressIncrement}
                        progress={progress}
                        lastComponent={lastComponent}
                        candidateSpecific={candidateConfig?.candidateSpecific}
                    />
                );
            case "completed":
                if (!lastComponent) window.scrollTo(0, 0);
                return (<Completed eventData={eventData}/>);
            default:
                // Only render Greetings when eventData has been loaded
                if (!isEventDataLoaded || !eventData || Object.keys(eventData).length === 0) {
                    return <div className="text-center py-5">Loading...</div>;
                }
                return <Greetings isEventActive={isEventActive} switchComponent={switchComponent}
                                  eventData={eventData}/>;
        }
    };
    return (
        <div
            className="d-flex flex-column justify-content-between"
            style={{height: "100vh"}}
        >
            <CandidateHeader
                switchComponent={switchComponent}
                progress={progress}
                step={step}
                id={id}
            />
            <Container
                className="assessment-main-container py-4"
                // style={{ width: "75%" }}
                fluid
            >
                {!isEventDataLoaded ? (
                    <div className="text-center py-5">Loading...</div>
                ) : isEventDataLoaded && (!eventData || Object.keys(eventData).length === 0) ? (
                    <Card className="br-15 card candidate-card shadow">
                        <CardBody className="text-center py-5">
                            <h4 className="mb-3">Event Not Found</h4>
                            <p className="text-muted">
                                The event you are looking for does not exist or has been removed.
                            </p>
                        </CardBody>
                    </Card>
                ) : (
                    <>
                        {activeTab === "basicInfo" ||
                        activeTab === "education" ||
                        activeTab === "experience" ||
                        activeTab === "orgQuestions" ||
                        activeTab === "candidateSpecific"
                            ? //     (
                            //   <img src={suitedBoy} id={"suitedBoy"} alt="" />
                            // )
                            null
                            : null}

                        <div className="br-15 card candidate-card shadow">
                            <CardHeader
                                className="pb-1 text-white bg-header"
                                style={{borderRadius: "15px 15px 0 0"}}
                            >
                                <div className="d-lg-none d-sm-block">
                                    <Slider {...settings} ref={sliderRef}>
                                        {candidateConfig?.basicInfo?.enabled && (
                                            <div
                                                className="step-container"
                                                onClick={() => {
                                                    if (isCompleted.candidateSpecific) {
                                                    } else if (isEventActive) {
                                                        switchComponent("basicInfo");
                                                        setProgress(0);
                                                    }
                                                }}
                                            >
                                                <img
                                                    src={activeTab === "basicInfo" ? step1Active : step1}
                                                    alt=""
                                                />

                                                <div
                                                    className={`mt-1 ${activeTab === "basicInfo" && "active-text"
                                                    }`}
                                                >
                                                    <span>Basic Information</span>
                                                </div>
                                            </div>
                                        )}
                                        {candidateConfig?.education?.enabled && (
                                            <div
                                                className="step-container"
                                                onClick={() => {
                                                    if (isCompleted.candidateSpecific) {
                                                    } else {
                                                        if (isCompleted.basicInfo) {
                                                            switchComponent("education");
                                                            setProgress(progressIncrement);
                                                        } else {
                                                            NotificationManager.error(
                                                                "Please complete previous step first!"
                                                            );
                                                        }
                                                    }
                                                }}
                                            >
                                                <img
                                                    src={activeTab === "education" ? step2Active : step2}
                                                    alt=""
                                                />

                                                <div
                                                    className={`mt-1 ${activeTab === "education" && "active-text"
                                                    }`}
                                                >
                                                    <span>Educational Information</span>
                                                </div>
                                            </div>
                                        )}
                                        {candidateConfig?.experience?.enabled && (
                                            <div
                                                className="step-container"
                                                onClick={() => {
                                                    if (isCompleted.candidateSpecific) {
                                                    } else {
                                                        if (isCompleted.education) {
                                                            switchComponent("experience");
                                                            setProgress(progressIncrement * 2);
                                                        } else {
                                                            NotificationManager.error(
                                                                "Please complete previous step first!"
                                                            );
                                                        }
                                                    }
                                                }}
                                            >
                                                <img
                                                    src={activeTab === "experience" ? step3Active : step3}
                                                    alt=""
                                                />
                                                <div
                                                    className={`mt-1 ${activeTab === "experience" && "active-text"
                                                    }`}
                                                >
                            <span>
                              <span className="text-nowrap">Internships &</span>{" "}
                                Experience
                            </span>
                                                </div>
                                            </div>
                                        )}
                                        {candidateConfig?.orgQuestions?.enabled && (
                                            <div
                                                className="step-container"
                                                onClick={() => {
                                                    if (isCompleted.candidateSpecific) {
                                                    } else {
                                                        if (isCompleted.experience) {
                                                            switchComponent("orgQuestions");
                                                            setProgress(progressIncrement * 3);
                                                        } else {
                                                            NotificationManager.error(
                                                                "Please complete previous step first!"
                                                            );
                                                        }
                                                    }
                                                }}
                                            >
                                                <img
                                                    src={activeTab === "orgQuestions" ? step4Active : step4}
                                                    alt=""
                                                />
                                                <div
                                                    className={`mt-1 ${activeTab === "orgQuestions" && "active-text"
                                                    }`}
                                                >
                            <span>
                              <span className="text-nowrap">Org Related</span>{" "}
                                Questions
                            </span>
                                                </div>
                                            </div>
                                        )}
                                        {candidateConfig?.candidateSpecific?.enabled && (
                                            <div
                                                className="step-container"
                                                onClick={() => {
                                                    if (isCompleted.candidateSpecific) {
                                                    } else {
                                                        if (isCompleted.orgQuestions) {
                                                            switchComponent("candidateSpecific");
                                                            setProgress(progressIncrement * 4);
                                                        } else {
                                                            NotificationManager.error(
                                                                "Please complete previous step first!"
                                                            );
                                                        }
                                                    }
                                                }}
                                            >
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    position: "relative"
                                                }}>
                                                    {(isCompleted.candidateSpecific || (activeTab === "completed" && getLastEnabledStep() === "candidateSpecific")) && (
                                                        <img
                                                            src={checkLogo}
                                                            alt=""
                                                            style={{
                                                                width: "20px",
                                                                height: "20px",
                                                                marginRight: "-15px",
                                                                marginTop: "30px",
                                                                zIndex: 1
                                                            }}
                                                        />
                                                    )}
                                                    <img
                                                        src={
                                                            activeTab === "candidateSpecific" ? step5Active : step5
                                                        }
                                                        alt=""
                                                        style={{
                                                            position: "relative",
                                                            zIndex: 0
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    className={`mt-1 ${activeTab === "candidateSpecific" && "active-text"
                                                    }`}
                                                >
                                                    <span>Candidate specific</span>
                                                </div>
                                            </div>
                                        )}

                                        <div
                                            className="step-container"
                                            onClick={() => {
                                                if (
                                                    isCompleted.candidateSpecific ||
                                                    candidateConfig?.candidateSpecific?.enabled === false
                                                ) {
                                                    switchComponent("completed");
                                                } else {
                                                    NotificationManager.error(
                                                        "Please complete previous step first!"
                                                    );
                                                }
                                            }}
                                        >
                                            <img
                                                src={activeTab === "completed" ? step6Active : step6}
                                                alt=""
                                            />
                                            <div
                                                className={`mt-1 ${activeTab === "completed" && "active-text"
                                                }`}
                                            >
                                                <span>Completed</span>
                                            </div>
                                        </div>
                                        <div className="step-container"/>
                                        <div className="step-container"/>
                                    </Slider>
                                    {/*<Button onClick={()=>goToSlide(5)}>Click</Button>*/}
                                </div>
                                {/*Main content*/}

                                <Container className="justify-content-center d-none d-lg-block">
                                    <Nav className="me-auto" navbar>
                                        <Row className="px-5">
                                            {candidateConfig?.basicInfo?.enabled === true ? (
                                                <>
                                                    <Col className="px-0">
                                                        <div
                                                            className="step-container"
                                                            onClick={() => {
                                                                if (isCompleted.candidateSpecific) {
                                                                } else if (isEventActive) {
                                                                    switchComponent("basicInfo");
                                                                    setProgress(0);
                                                                }
                                                            }}
                                                        >
                                                            <div style={{
                                                                display: "flex",
                                                                justifyContent: "center",   // Center the icons horizontally
                                                                alignItems: "center",       // Center the icons vertically (if needed)
                                                                position: "relative"        // Set relative position for checkLogo positioning
                                                            }}>

                                                                {/* Check logo icon positioned to the left of the main icon */}
                                                                {(isCompleted.basicInfo || (activeTab === "completed" && getLastEnabledStep() === "basicInfo")) && (
                                                                    <img
                                                                        src={checkLogo}
                                                                        alt=""
                                                                        style={{
                                                                            width: "20px",
                                                                            height: "20px",
                                                                            marginRight: "-15px",   // Negative margin to slightly overlap with main icon
                                                                            marginTop: "30px",
                                                                            zIndex: 1                // Ensure it appears on top if needed
                                                                        }}
                                                                    />
                                                                )}

                                                                {/* Main icon */}
                                                                <img
                                                                    src={
                                                                        activeTab === "basicInfo" ? step1Active : step1
                                                                    }
                                                                    alt=""
                                                                    style={{
                                                                        position: "relative",
                                                                        zIndex: 0
                                                                    }}
                                                                />
                                                            </div>

                                                            <div
                                                                className={`mt-1 ${activeTab === "basicInfo" && "active-text"}`}
                                                            >
                                                                <span>Basic Information</span>
                                                            </div>
                                                        </div>
                                                    </Col>


                                                    <Col className="px-0">
                                                        <div className="h-100 py-4">
                                                            <div className="hr mt-2"/>
                                                        </div>
                                                    </Col>
                                                </>
                                            ) : null}

                                            {candidateConfig?.education?.enabled === true ? (
                                                <>
                                                    <Col className="px-0">
                                                        <div
                                                            className="step-container"
                                                            onClick={() => {
                                                                if (isCompleted.candidateSpecific) {
                                                                } else {
                                                                    if (isCompleted.basicInfo) {
                                                                        switchComponent("education");
                                                                        setProgress(progressIncrement);
                                                                    } else {
                                                                        NotificationManager.error(
                                                                            "Please complete previous step first!"
                                                                        );
                                                                    }
                                                                }
                                                            }}
                                                        >

                                                            <div style={{
                                                                display: "flex",
                                                                justifyContent: "center",   // Center the icons horizontally
                                                                alignItems: "center",       // Center the icons vertically (if needed)
                                                                position: "relative"        // Set relative position for checkLogo positioning
                                                            }}>

                                                                {(isCompleted.education || (activeTab === "completed" && getLastEnabledStep() === "education")) && (
                                                                    <img
                                                                        src={checkLogo}
                                                                        alt=""
                                                                        style={{
                                                                            width: "20px",
                                                                            height: "20px",
                                                                            marginRight: "-15px",   // Negative margin to slightly overlap with main icon
                                                                            marginTop: "30px",
                                                                            zIndex: 1                // Ensure it appears on top if needed
                                                                        }}
                                                                    />
                                                                )}

                                                                <img
                                                                    src={
                                                                        activeTab === "education" ? step2Active : step2
                                                                    }
                                                                    style={{
                                                                        position: "relative",
                                                                        zIndex: 0
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div
                                                                className={`mt-1 ${activeTab === "education" && "active-text"
                                                                }`}
                                                            >
                                                                <span>Educational Information</span>
                                                            </div>

                                                        </div>
                                                    </Col>

                                                    <Col className="px-0">
                                                        <div className="h-100 py-4">
                                                            <div className="hr mt-2"/>
                                                        </div>
                                                    </Col>
                                                </>
                                            ) : null}
                                            {candidateConfig?.experience?.enabled === true ? (
                                                <>
                                                    <Col className="px-0">
                                                        <div
                                                            className="step-container"
                                                            onClick={() => {
                                                                if (isCompleted.candidateSpecific) {
                                                                } else {
                                                                    if (isCompleted.education) {
                                                                        switchComponent("experience");
                                                                        setProgress(progressIncrement * 2);
                                                                    } else {
                                                                        NotificationManager.error(
                                                                            "Please complete previous step first!"
                                                                        );
                                                                    }
                                                                }
                                                            }}
                                                        >


                                                            <div style={{
                                                                display: "flex",
                                                                justifyContent: "center",   // Center the icons horizontally
                                                                alignItems: "center",       // Center the icons vertically (if needed)
                                                                position: "relative"        // Set relative position for checkLogo positioning
                                                            }}>


                                                                {console.log(isCompleted?.experience)}
                                                                {(isCompleted.experience || (activeTab === "completed" && getLastEnabledStep() === "experience")) && (
                                                                    <img
                                                                        src={checkLogo}
                                                                        alt=""
                                                                        style={{
                                                                            width: "20px",
                                                                            height: "20px",
                                                                            marginRight: "-15px",   // Negative margin to slightly overlap with main icon
                                                                            marginTop: "30px",
                                                                            zIndex: 1                // Ensure it appears on top if needed
                                                                        }}
                                                                    />
                                                                )}

                                                                <img
                                                                    src={
                                                                        activeTab === "experience" ? step3Active : step3
                                                                    }
                                                                    style={{
                                                                        position: "relative",
                                                                        zIndex: 0
                                                                    }}
                                                                    alt=""
                                                                />

                                                            </div>
                                                            <div
                                                                className={`mt-1 ${activeTab === "experience" && "active-text"
                                                                }`}
                                                            >
                            <span>
                              <span className="text-nowrap">Internships &</span>{" "}
                                Experience
                            </span>
                                                            </div>
                                                        </div>
                                                    </Col>

                                                    <Col>
                                                        <div className="h-100 py-4">
                                                            <div className="hr mt-2"/>
                                                        </div>
                                                    </Col>
                                                </>
                                            ) : null}

                                            {candidateConfig?.orgQuestions?.enabled === true ? (
                                                <>
                                                    <Col className="px-0">
                                                        <div
                                                            className="step-container"
                                                            onClick={() => {
                                                                if (isCompleted.candidateSpecific) {
                                                                } else {
                                                                    if (isCompleted.experience) {
                                                                        switchComponent("orgQuestions");
                                                                        setProgress(progressIncrement * 3);
                                                                    } else {
                                                                        NotificationManager.error(
                                                                            "Please complete previous step first!"
                                                                        );
                                                                    }
                                                                }
                                                            }}
                                                        >

                                                            <div style={{
                                                                display: "flex",
                                                                justifyContent: "center",   // Center the icons horizontally
                                                                alignItems: "center",       // Center the icons vertically (if needed)
                                                                position: "relative"        // Set relative position for checkLogo positioning
                                                            }}>


                                                                {(isCompleted.orgQuestions || (activeTab === "completed" && getLastEnabledStep() === "orgQuestions")) && (
                                                                    <img
                                                                        src={checkLogo}
                                                                        alt=""
                                                                        style={{
                                                                            width: "20px",
                                                                            height: "20px",
                                                                            marginRight: "-15px",   // Negative margin to slightly overlap with main icon
                                                                            marginTop: "30px",
                                                                            zIndex: 1                // Ensure it appears on top if needed
                                                                        }}
                                                                    />
                                                                )}

                                                                <img
                                                                    src={
                                                                        activeTab === "orgQuestions" ? step4Active : step4
                                                                    }
                                                                    style={{
                                                                        position: "relative",
                                                                        zIndex: 0
                                                                    }}
                                                                    alt=""
                                                                />

                                                            </div>

                                                            <div
                                                                className={`mt-1 ${activeTab === "orgQuestions" && "active-text"
                                                                }`}
                                                            >
                            <span>
                              <span className="text-nowrap">Org Related</span>{" "}
                                Questions
                            </span>
                                                            </div>
                                                        </div>
                                                    </Col>

                                                    <Col className="px-0">
                                                        <div className="h-100 py-4">
                                                            <div className="hr mt-2"/>
                                                        </div>
                                                    </Col>
                                                </>
                                            ) : null}

                                            {candidateConfig?.candidateSpecific?.enabled && (
                                                // isCompleted.candidateSpecific
                                                <>
                                                    <Col className="px-0">
                                                        <div
                                                            className="step-container"
                                                            onClick={() => {
                                                                if (isCompleted.candidateSpecific) {
                                                                } else {
                                                                    if (isCompleted.orgQuestions) {
                                                                        switchComponent("candidateSpecific");
                                                                        setProgress(progressIncrement * 4);
                                                                    } else {
                                                                        NotificationManager.error(
                                                                            "Please complete previous step first!"
                                                                        );
                                                                    }
                                                                }
                                                            }}
                                                        >

                                                            <div style={{
                                                                display: "flex",
                                                                justifyContent: "center",   // Center the icons horizontally
                                                                alignItems: "center",       // Center the icons vertically (if needed)
                                                                position: "relative"        // Set relative position for checkLogo positioning
                                                            }}>


                                                                {(isCompleted.candidateSpecific || (activeTab === "completed" && getLastEnabledStep() === "candidateSpecific")) && (
                                                                    <img
                                                                        src={checkLogo}
                                                                        alt=""
                                                                        style={{
                                                                            width: "20px",
                                                                            height: "20px",
                                                                            marginRight: "-15px",   // Negative margin to slightly overlap with main icon
                                                                            marginTop: "30px",
                                                                            zIndex: 1                // Ensure it appears on top if needed
                                                                        }}
                                                                    />
                                                                )}

                                                                <img
                                                                    src={
                                                                        activeTab === "candidateSpecific"
                                                                            ? step5Active
                                                                            : step5
                                                                    }
                                                                    style={{
                                                                        position: "relative",
                                                                        zIndex: 0
                                                                    }}
                                                                    alt=""
                                                                />

                                                            </div>

                                                            <div
                                                                className={`mt-1 ${activeTab === "candidateSpecific" && "active-text"
                                                                }`}
                                                            >
                                                                <span>Candidate specific</span>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col className="px-0">
                                                        <div className="h-100 py-4">
                                                            <div className="hr mt-2"/>
                                                        </div>
                                                    </Col>
                                                </>
                                            )}

                                            <Col className="px-0">
                                                <div
                                                    className="step-container"
                                                    onClick={() => {
                                                        if (isCompleted.candidateSpecific) {
                                                            switchComponent("completed");
                                                        } else {
                                                            NotificationManager.error(
                                                                "Please complete previous step first!"
                                                            );
                                                        }
                                                    }}
                                                >

                                                    <div style={{
                                                        display: "flex",
                                                        justifyContent: "center",   // Center the icons horizontally
                                                        alignItems: "center",       // Center the icons vertically (if needed)
                                                        position: "relative"        // Set relative position for checkLogo positioning
                                                    }}>


                                                        {isCompleted.basicInfo &&
                                                            isCompleted.education &&
                                                            isCompleted.experience &&
                                                            isCompleted.orgQuestions &&
                                                            isCompleted.candidateSpecific && (
                                                                <img
                                                                    src={checkLogo}
                                                                    alt=""
                                                                    style={{
                                                                        width: "20px",
                                                                        height: "20px",
                                                                        marginRight: "-15px",   // Negative margin to slightly overlap with main icon
                                                                        marginTop: "30px",
                                                                        zIndex: 1                // Ensure it appears on top if needed
                                                                    }}
                                                                />
                                                            )}
                                                        <img
                                                            src={activeTab === "completed" ? step6Active : step6}
                                                            style={{
                                                                position: "relative",
                                                                zIndex: 0
                                                            }}
                                                            alt=""
                                                        />
                                                    </div>

                                                    <div
                                                        className={`mt-1 ${activeTab === "completed" && "active-text"
                                                        }`}
                                                    >
                                                        <span>Completed</span>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Nav>
                                </Container>
                                {/*Main content*/}
                            </CardHeader>
                            <CardBody className="px-0 candidate-card-body">
                                <Container>{renderContent()}</Container>
                            </CardBody>
                        </div>
                        {activeTab === "basicInfo" ||
                        activeTab === "education" ||
                        activeTab === "experience" ||
                        activeTab === "orgQuestions" ||
                        activeTab === "candidateSpecific"
                            ? // <img src={suitedGirl} id={"suitedGirl"} alt=""/>
                            null
                            : null}

                        {/*<div className={(activeTab === 'basicInfo' || activeTab === 'education' || activeTab === 'experience' || activeTab === 'orgQuestions' || activeTab === 'candidateSpecific')? "text-right mt-4 mb-5":"text-center mt-4 mb-5"}>
                        <img src={logo} alt="logo"/>
                    </div>*/}
                    </>
                )}
            </Container>
            <div className="assessment-footer py-3">
                <Container
                    fluid
                    className="d-flex align-items-center justify-content-between flex-wrap assessment-main-container"
                >
                    <img src={activ8Logo}/>
                    <span className="text-sm footer-text">
            © {new Date().getFullYear()}{" "}
                        <a
                            className="ml-1 text-dark"
                            href="https://activ8games.com"
                            target="_blank"
                        >
              All rights reserved Activ8Games
            </a>
          </span>
                </Container>
            </div>
        </div>
    );
};

export default CandidateFlow;
